import { Button as ButtonMaterial, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles({
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
});

const Button = (props) => {
    const classes = useStyles();

    return (
        <ButtonMaterial
            variant="contained"
            color="primary"
            {...props}
        >
            {props.isLoadingAction && <CircularProgress className={classes.loading} color="primary" size={20} />}
            {props.children}
        </ButtonMaterial>
    )
}

export default Button;